module.exports = __webpack_public_path__ + "static/media/ic_config.a9e2d201.svg";